<template>
  <div class="product-detail">
    <div class="info-item title">{{ $t('shared.bindProduct') }}</div>
    <div class="info-item person-info">
      <span class="user-name txt-ellipsis">{{ infoObj.nickname }}</span>
      <span class="user-type txt-ellipsis">{{ infoObj.job }}</span>
    </div>
    <div class="info-item">{{ $t('shared.store') }}： <span class="store-name" @click="toUrl">{{ infoObj.customerName }}</span></div>
    <div class="info-item">{{ $t('shared.submissionTime') }}：{{ infoObj.localCreateTime }}</div>
    <div class="info-item">{{ $t('shared.auditResult') }}：<span :style="`color: ${infoObj.statusColor}`">{{ infoObj.statusText }}</span></div>
    <div class="info-item">{{ $t('shared.bindProduct') }} {{ infoObj.totalQuantity }} {{ $t('form.pcs') }}，{{ $t('shared.earnedPoints', { totalIntegral: infoObj.totalIntegral }) }}</div>
    <div class="info-item" v-if="infoObj.detailList && infoObj.detailList.length > 0">
      <div>{{ $t('shared.productDetails') }}：</div>
      <div v-for="(subItem, subIndex) in infoObj.detailList" :key="subItem.id" class="code-item">{{ $t('shared.sN') }}{{ subIndex + 1 }}：{{ subItem.snCode }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    infoObj: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    toUrl () {
      this.$router.push(`/storeExpansion/storeMappingDetail?customerId=${this.infoObj.customerId}`)
    }
  }
}
</script>

<style lang="less" scoped>
.product-detail {
  flex: 1;
  padding: 28px 23px;
  font-size: 13px;
  color: #333;
  .info-item {
    padding: 6px 0;
  }
  .store-name {
    color: #307bff;
    text-decoration: underline;
  }
  .person-info {
    display: flex;
    align-items: center;
    .user-name {
      max-width: 180px;
    }
    .user-type {
      max-width: 75px;
      padding: 2px 5px;
      text-align: center;
      border: 1px solid #307bff;
      color: #307bff;
      margin-left: 5px;
      font-size: 12px;
    }
  }
  .title {
    font-weight: bold;
  }
  .code-item {
    padding: 12px 10px;
    background-color: #f2f2f2;
    margin-bottom: 5px;
    &:nth-child(2) {
      margin-top: 6px;
    }
  }
}
</style>
